// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LastLoginCheckRequestModel from '../../model/last-login-check-request-model';
import LastLoginCheckRequestDTO from '../dto/last-login-check-request-dto';
import dtoSchema from '../schemas/last-login-check-request-schema';

export default abstract class LastLoginCheckRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LastLoginCheckRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.organisationId = data.organisationId;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;
  /**
  * @type {uuid}
  */
  organisationId?: string;

  static toModel(dto: DeepPartial<LastLoginCheckRequestDTO>): LastLoginCheckRequestModel;
  static toModel(dto: DeepPartial<LastLoginCheckRequestDTO> | undefined | null): LastLoginCheckRequestModel | undefined;
  static toModel(dto: DeepPartial<LastLoginCheckRequestDTO> | undefined | null): LastLoginCheckRequestModel | undefined {
    return dto ? new LastLoginCheckRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LastLoginCheckRequestModel> | LastLoginCheckRequestModel): LastLoginCheckRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      organisationId: unwrapped.organisationId,
    } as LastLoginCheckRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LastLoginCheckRequestModel, can not map to LastLoginCheckRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
